import React, { FunctionComponent, useCallback, useMemo } from "react"
import { Link, useHistory, useRouteMatch } from "react-router-dom"
// import DotButton from "../../components/Buttons/DotButton"

import { eImageVersions /* iImageVersions */ } from "../../definitions/Image"
import { useImage } from "../../hooks/useImage"
import { useImageUrl } from "../../hooks/useImageUrl"
import DotButton from "../../components/Buttons/DotButton"

interface iProps {
  cover?: string
  title?: string
}

const PackagesHeader: FunctionComponent<iProps> = ({ title, cover }) => {
  const history = useHistory()
  const handleHisoryBack = useCallback((e: React.SyntheticEvent) => {
    e.preventDefault()
    history.goBack()
  }, [])

  const { file } = useImage({
    fileId: cover,
    fileCollection: "Files_ArtPiecesPreview",
  })

  const coverImage =
    file && useImageUrl(eImageVersions.XLWRegular, file.versions)

  return (
    <div className="inspector-header">
      <div className="inspector-cover-wrap">
        <div
          className="inspector-cover"
          style={{ backgroundImage: `url(${coverImage})` }}
        ></div>
        <div className="inspector-cover-overlay">
          <div className="inspector-headline">
            <Link to="#" onClick={handleHisoryBack}>
              <i className="fa fa-chevron-left"></i>
              <span>Back</span>
            </Link>
          </div>
          <h1 className="inspector-title">{title}</h1>
        </div>
      </div>
    </div>
  )
}

export default PackagesHeader
